document.addEventListener("DOMContentLoaded", function () {
  // =========================
  // Email & phone labels
  // =========================

  document
    .querySelectorAll('a[href^="mailto:"], a[href^="tel:"]')
    .forEach(function (el) {
      const href = el.getAttribute("href");
      if (
        el.getAttribute("role") === "button" ||
        el.classList.contains("button") ||
        el.classList.contains("btn")
      ) {
        return;
      }

      if (href && href.startsWith("mailto:")) {
        const email = href.replace("mailto:", "").trim();
        const existing = el.getAttribute("aria-label");

        if (existing) {
          el.setAttribute("aria-label", existing + ", Email address: " + email);
        } else {
          el.setAttribute("aria-label", "Email address: " + email);
        }
      }

      // TEL
      if (href && href.startsWith("tel:")) {
        const existing = el.getAttribute("aria-label");

        if (existing) {
          return;
        }

        const text = el.textContent.trim();
        el.setAttribute("aria-label", "Phone number: " + text);
      }
    });

  // =========================
  // Third party warning
  // =========================
  const warningText =
    "Redirecting to a third-party website (opens in a new tab).";

  function isThirdParty(url) {
    try {
      const linkHost = new URL(url, window.location.href).hostname;
      return linkHost && linkHost !== window.location.hostname;
    } catch {
      return false;
    }
  }

  function handleExternalLinks() {
    document.querySelectorAll("a").forEach(function (link) {
      const href = link.getAttribute("href");
      if (!href || !isThirdParty(href)) return;

      link.setAttribute("target", "_blank");
      link.setAttribute("rel", "noopener noreferrer");

      const img = link.querySelector("img");

      if (img) {
        link.removeAttribute("aria-label");

        let alt = img.getAttribute("alt") || "";
        if (!alt.includes(warningText)) {
          img.setAttribute("alt", alt ? alt + ", " + warningText : warningText);
        }
        return;
      }

      const aria = link.getAttribute("aria-label");
      const text = link.textContent.trim();

      if (aria) {
        if (!aria.includes(warningText)) {
          link.setAttribute("aria-label", aria + ", " + warningText);
        }
      } else {
        if (!text) return;

        link.setAttribute("aria-label", text + ", " + warningText);
      }
    });
  }

  setTimeout(handleExternalLinks, 500);

  // =========================
  // Hide Flickity dots from screen readers
  // =========================

  setTimeout(function () {
    document.querySelectorAll(".flickity-page-dots").forEach(function (dots) {
      dots.setAttribute("aria-hidden", "true");
    });
  }, 500);

  // =========================
  // Prodcut description
  // =========================
  function updateCardCollapsibleDisplay() {
    document.querySelectorAll(".card").forEach(function (card) {
      var btn = card.querySelector(".card__collapsible-button");
      var panel = card.querySelector(".card__collapsible");

      if (btn && panel) {
        if (btn.getAttribute("aria-expanded") === "true") {
          panel.style.display = "";
          panel.style.height = "auto";
        } else {
          panel.style.display = "none";
          panel.style.height = "";
        }
      }
    });
  }

  updateCardCollapsibleDisplay();

  document.addEventListener("click", function (e) {
    if (e.target.closest(".card__collapsible-button")) {
      setTimeout(updateCardCollapsibleDisplay, 100);
    }
  });

  // =========================
  // Desktop menu click behavior
  // =========================

  function closeDesktopMenuItem(item) {
    if (!item) return;

    const trigger = item.querySelector(
      ':scope > [data-type="menuitem"][aria-controls]',
    );
    const menu = item.querySelector(":scope > [aria-hidden]");

    item.classList.remove("is-dropdown-open");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
    }

    if (menu) {
      menu.setAttribute("aria-hidden", "true");
    }

    item.querySelectorAll(".is-dropdown-open").forEach(function (childItem) {
      closeDesktopMenuItem(childItem);
    });
  }

  function openDesktopMenuItem(trigger) {
    const item = trigger.parentElement;
    const menu = document.getElementById(trigger.getAttribute("aria-controls"));

    if (!item || !menu) return;

    Array.from(item.parentElement.children).forEach(function (sibling) {
      if (sibling !== item && sibling.classList.contains("is-dropdown-open")) {
        closeDesktopMenuItem(sibling);
      }
    });

    item.classList.add("is-dropdown-open");
    trigger.setAttribute("aria-expanded", "true");
    menu.setAttribute("aria-hidden", "false");
  }

  function setupDesktopClickMenu() {
    const desktopNav = document.querySelector(".nav-bar, .header__desktop-nav");

    if (!desktopNav) return;

    desktopNav.addEventListener(
      "click",
      function (event) {
        const trigger = event.target.closest(
          '[data-type="menuitem"][aria-controls]',
        );

        if (!trigger || !desktopNav.contains(trigger)) return;

        const item = trigger.parentElement;
        const isOpen = trigger.getAttribute("aria-expanded") === "true";

        event.preventDefault();
        event.stopImmediatePropagation();

        if (isOpen) {
          closeDesktopMenuItem(item);
        } else {
          openDesktopMenuItem(trigger);
        }
      },
      true,
    );

    document.addEventListener(
      "click",
      function (event) {
        if (desktopNav.contains(event.target)) return;

        desktopNav
          .querySelectorAll(".is-dropdown-open")
          .forEach(function (item) {
            closeDesktopMenuItem(item);
          });
      },
      true,
    );
  }

  setupDesktopClickMenu();

  // =========================
  // Mega-menu arrow click behavior
  // =========================

  function setupMegaMenuArrowButtons() {
    if (!window.jQuery) return;

    const $ = window.jQuery;

    function getItemLabel($item) {
      return $.trim($item.find("a").first().text()) || "submenu";
    }

    function closeAllMegaPanels() {
      $(".mega-menu__main")
        .removeClass("active")
        .find(".arrow-con")
        .attr("aria-expanded", "false");

      $(".mega-menu__menus").hide().attr("aria-hidden", "true");
    }

    function openMegaPanel($item) {
      const menusId = $item.attr("data-menus-id");
      const $panel = $("#" + menusId);

      if (!menusId || !$panel.length) return;

      closeAllMegaPanels();

      $item.addClass("active");
      $item.find(".arrow-con").first().attr("aria-expanded", "true");

      $panel.css("display", "flex").attr("aria-hidden", "false");
    }

    function closeMegaPanel($item) {
      const menusId = $item.attr("data-menus-id");
      const $panel = $("#" + menusId);

      $item.removeClass("active");
      $item.find(".arrow-con").first().attr("aria-expanded", "false");

      $panel.hide().attr("aria-hidden", "true");
    }

    $(".mega-menu__main").each(function () {
      const $item = $(this);
      const menusId = $item.attr("data-menus-id");
      const $panel = menusId ? $("#" + menusId) : $();

      if (!menusId || !$panel.length) return;

      const $arrow = $item.find(".arrow-con").first();

      if (!$arrow.length) return;

      $arrow.attr({
        role: "button",
        tabindex: "0",
        "aria-label": "Toggle submenu for " + getItemLabel($item),
        "aria-controls": menusId,
        "aria-expanded": $item.hasClass("active") ? "true" : "false",
      });

      $panel.attr("aria-hidden", $item.hasClass("active") ? "false" : "true");
    });

    $(".mega-menu__main .arrow-con")
      .off("click.megaArrow keydown.megaArrow")
      .on("click.megaArrow keydown.megaArrow", function (event) {
        if (
          event.type === "keydown" &&
          event.key !== "Enter" &&
          event.key !== " "
        ) {
          return;
        }

        event.preventDefault();
        event.stopPropagation();

        const $item = $(this).closest(".mega-menu__main");

        if ($item.hasClass("active")) {
          closeMegaPanel($item);
        } else {
          openMegaPanel($item);
        }
      });

    $(".mega-menu__main")
      .off("focusin.megaArrowFocus focusout.megaArrowFocus")
      .on("focusin.megaArrowFocus", function () {
        $(this).addClass("is-focused");
      })
      .on("focusout.megaArrowFocus", function () {
        const item = this;

        setTimeout(function () {
          if (!item.contains(document.activeElement)) {
            $(item).removeClass("is-focused");
          }
        }, 0);
      });

    $(document)
      .off("click.megaArrowOutside")
      .on("click.megaArrowOutside", function (event) {
        if ($(event.target).closest(".mega-menu__inner").length) return;
        closeAllMegaPanels();
      });

    $(document)
      .off("keydown.megaArrowEscape")
      .on("keydown.megaArrowEscape", function (event) {
        if (event.key !== "Escape") return;

        const $activeArrow = $(".mega-menu__main.active .arrow-con").first();

        closeAllMegaPanels();

        if ($activeArrow.length) {
          $activeArrow.trigger("focus");
        }
      });
  }

  setupMegaMenuArrowButtons();

  // =========================
  // Desktop dropdown Escape close
  // =========================

  document.addEventListener("keydown", function (event) {
    if (event.key !== "Escape") return;

    const openItems = Array.from(
      document.querySelectorAll(
        ".nav-bar .is-dropdown-open, .header__desktop-nav .is-dropdown-open",
      ),
    );

    if (!openItems.length) return;

    event.preventDefault();

    const deepestOpenItem = openItems[openItems.length - 1];
    const trigger = deepestOpenItem.querySelector(
      ':scope > [data-type="menuitem"][aria-controls]',
    );
    const menu = trigger
      ? document.getElementById(trigger.getAttribute("aria-controls"))
      : deepestOpenItem.querySelector(":scope > [aria-hidden]");

    deepestOpenItem.classList.remove("is-dropdown-open");

    if (trigger) {
      trigger.setAttribute("aria-expanded", "false");
      trigger.focus();
    }

    if (menu) {
      menu.setAttribute("aria-hidden", "true");
    }

    deepestOpenItem
      .querySelectorAll(".is-dropdown-open")
      .forEach(function (childItem) {
        const childTrigger = childItem.querySelector(
          ':scope > [data-type="menuitem"][aria-controls]',
        );
        const childMenu = childTrigger
          ? document.getElementById(childTrigger.getAttribute("aria-controls"))
          : childItem.querySelector(":scope > [aria-hidden]");

        childItem.classList.remove("is-dropdown-open");

        if (childTrigger) {
          childTrigger.setAttribute("aria-expanded", "false");
        }

        if (childMenu) {
          childMenu.setAttribute("aria-hidden", "true");
        }
      });
  });

  // =========================
  // Mega-menu tab / tabpanel state sync
  // =========================

  function setupMegaMenuTabStateSync() {
    if (!window.jQuery) return;

    const $ = window.jQuery;

    function getItemLabel($item) {
      return $.trim($item.find("a").first().text()) || "submenu";
    }

    function syncMegaTabState() {
      $(".mega-menu__main").each(function () {
        const $item = $(this);
        const menusId = $item.attr("data-menus-id");
        const $panel = menusId ? $("#" + menusId) : $();
        const $arrow = $item.find(".arrow-con").first();

        if (!menusId || !$panel.length || !$arrow.length) return;

        const arrowId = "mega-menu-tab-" + menusId;
        const isOpen =
          $item.hasClass("active") ||
          $panel.css("display") !== "none" ||
          $panel.attr("aria-hidden") === "false";

        $arrow.attr({
          id: arrowId,
          role: "tab",
          tabindex: "0",
          "aria-label": "Toggle submenu for " + getItemLabel($item),
          "aria-controls": menusId,
          "aria-selected": isOpen ? "true" : "false",
          "aria-expanded": isOpen ? "true" : "false",
        });

        $panel.attr({
          role: "tabpanel",
          "aria-labelledby": arrowId,
          "aria-hidden": isOpen ? "false" : "true",
        });
      });
    }

    syncMegaTabState();

    $(".mega-menu__main .arrow-con")
      .off("click.megaTabStateSync keydown.megaTabStateSync")
      .on("click.megaTabStateSync keydown.megaTabStateSync", function () {
        setTimeout(syncMegaTabState, 0);
      });

    $(".mega-menu__main")
      .off(
        "mouseenter.megaTabStateSync mouseleave.megaTabStateSync focusin.megaTabStateSync focusout.megaTabStateSync",
      )
      .on(
        "mouseenter.megaTabStateSync mouseleave.megaTabStateSync focusin.megaTabStateSync focusout.megaTabStateSync",
        function () {
          setTimeout(syncMegaTabState, 0);
        },
      );

    $(document)
      .off("click.megaTabStateSync keydown.megaTabStateSync")
      .on("click.megaTabStateSync keydown.megaTabStateSync", function () {
        setTimeout(syncMegaTabState, 0);
      });
  }

  setupMegaMenuTabStateSync();

  // =========================
  // faq-answer hidden funct
  // =========================
  function updateFaqHidden() {
    document.querySelectorAll(".faq__item-wrapper").forEach(function (item) {
      var btn = item.querySelector(".faq__question.heading.h4");
      var answer = item.querySelector(".faq__answer-wrapper");
      if (!btn || !answer) return;

      var open = btn.getAttribute("aria-expanded") === "true";
      answer.hidden = !open;
      answer.style.height = open ? "auto" : "0";
    });
  }

  updateFaqHidden();

  document.addEventListener("click", function (e) {
    if (e.target.closest(".faq__question.heading.h4")) {
      setTimeout(updateFaqHidden, 100);
    }
  });

  // =========================
  // Mobile Menu – Focus Management
  // =========================
  (function () {
    function setupMobileMenuFocusManagement() {
      var mobileMenu = document.querySelector('.mobile-menu[role="dialog"]');
      if (!mobileMenu) return;

      document.addEventListener("click", function (event) {
        var trigger = event.target.closest('[data-action="open-panel"]');

        if (!trigger || !mobileMenu.contains(trigger)) return;

        var panelId = trigger.getAttribute("aria-controls");
        if (!panelId) return;

        var panel = document.getElementById(panelId);
        if (!panel) return;

        var backButton = panel.querySelector('[data-action="close-panel"]');
        if (!backButton) return;

        var focused = false;
        function doFocus() {
          if (focused) return;
          focused = true;
          backButton.focus();
        }
        function onTransitionEnd(e) {
          if (e.propertyName !== "transform" && e.propertyName !== "visibility")
            return;
          panel.removeEventListener("transitionend", onTransitionEnd);
          doFocus();
        }

        panel.addEventListener("transitionend", onTransitionEnd);

        setTimeout(doFocus, 550);
      });
      mobileMenu.addEventListener(
        "click",
        function (event) {
          var backButton = event.target.closest('[data-action="close-panel"]');
          if (!backButton) return;

          var panel = backButton.closest(".mobile-menu__panel.is-open");
          if (!panel || !panel.id) return;

          var trigger = mobileMenu.querySelector(
            '[data-action="open-panel"][aria-controls="' + panel.id + '"]',
          );
          if (!trigger) return;

          requestAnimationFrame(function () {
            trigger.focus();
          });
        },
        true,
      );
    }

    if (document.readyState === "loading") {
      document.addEventListener(
        "DOMContentLoaded",
        setupMobileMenuFocusManagement,
      );
    } else {
      setupMobileMenuFocusManagement();
    }
  })();

  // =========================
  // Mobile Menu – Close Drawer Button (screen reader)
  // =========================

  (function () {
    function setupCloseDrawerButton() {
      var mobileMenu = document.querySelector('.mobile-menu[role="dialog"]');
      if (!mobileMenu) return;

      var hamburger = document.querySelector(
        '[data-action="toggle-menu"][aria-controls="mobile-menu"]',
      );
      if (!hamburger) return;

      mobileMenu.addEventListener("click", function (event) {
        var closeBtn = event.target.closest(".close-menudrawer-btn");
        if (!closeBtn) return;

        hamburger.click();

        requestAnimationFrame(function () {
          hamburger.focus();
        });
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", setupCloseDrawerButton);
    } else {
      setupCloseDrawerButton();
    }
  })();

  // accordian state update
  document.querySelectorAll(".recipe-accordion__label").forEach((label) => {
    label.addEventListener("click", function () {
      this.setAttribute(
        "aria-expanded",
        this.classList.contains("active") ? "false" : "true",
      );
    });
  });

  //flickly role and tabindex issue on rebuy product div
  (function () {
    const selector = ".rebuy-product-grid.flickity-enabled";

    function cleanRebuyGrid(element) {
      if (!(element instanceof Element) || !element.matches(selector)) {
        return;
      }

      element.removeAttribute("role");
      element.removeAttribute("tabindex");
    }

    function scan(node) {
      if (!(node instanceof Element)) return;

      cleanRebuyGrid(node);
      node.querySelectorAll(selector).forEach(cleanRebuyGrid);
    }

    function initialize() {
      // Clean existing elements
      scan(document.documentElement);

      // Watch for Flickity adding classes or attributes later
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.type === "attributes") {
            cleanRebuyGrid(mutation.target);
          }

          if (mutation.type === "childList") {
            mutation.addedNodes.forEach(scan);
          }
        });
      });

      observer.observe(document.documentElement, {
        subtree: true,
        childList: true,
        attributes: true,
        attributeFilter: ["class", "role", "tabindex"],
      });
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", initialize, { once: true });
    } else {
      initialize();
    }
  })();
  //================= END ===============//
});
